import React, { useState, useEffect, useRef } from 'react';
import Sidebar from '../components/Sidebar';
import { MapContainer, TileLayer, Marker, Tooltip, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import axios from 'axios';
import { io } from 'socket.io-client';

const API = 'https://app.b3rastreamento.com.br/api';
const SOCKET_URL = 'https://b3rastreamento.com.br';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

const criarIcone = (cor, icone) => L.divIcon({
  className: '',
  html: `<div style="background:${cor};border:3px solid white;border-radius:50%;width:36px;height:36px;display:flex;align-items:center;justify-content:center;font-size:18px;box-shadow:0 2px 8px rgba(0,0,0,0.3)">${icone}</div>`,
  iconSize: [36, 36],
  iconAnchor: [18, 18],
});

function EnderecoInline({ lat, lng }) {
  const [end, setEnd] = useState(null);
  useEffect(() => {
    let mounted = true;
    const buscar = async () => {
      try {
        const res = await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json&accept-language=pt-BR`);
        const data = await res.json();
        if (mounted && data?.address) {
          const a = data.address;
          const rua = a.road || a.pedestrian || a.footway || a.residential || '';
          const cidade = a.city || a.town || a.village || a.municipality || a.county || '';
          const estado = a.state || '';
          setEnd(`${rua ? rua + ', ' : ''}${cidade}${estado ? ' — ' + estado : ''}`);
        }
      } catch {}
    };
    buscar();
    return () => { mounted = false; };
  }, [lat, lng]);
  return <span>{end || `${parseFloat(lat).toFixed(4)}, ${parseFloat(lng).toFixed(4)}`}</span>;
}

// Centraliza o mapa no veículo assim que ele é selecionado (clique na grid ou no marcador)
function CentralizarMapa({ alvoId, lat, lng }) {
  const map = useMap();
  useEffect(() => {
    if (!alvoId || !lat || !lng) return;
    map.flyTo([parseFloat(lat), parseFloat(lng)], Math.max(map.getZoom(), 15), { duration: 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alvoId]);
  return null;
}

function TelaSemContrato({ token, cor }) {
  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
      <div style={{ background: 'white', borderRadius: '16px', padding: '40px', maxWidth: '480px', width: '100%', textAlign: 'center', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
        <div style={{ fontSize: '64px', marginBottom: '16px' }}>📋</div>
        <h2 style={{ color: '#333', margin: '0 0 12px', fontSize: '22px' }}>Assinatura Pendente</h2>
        <p style={{ color: '#666', marginBottom: '24px', lineHeight: '1.6' }}>
          Para acessar o sistema de rastreamento, você precisa assinar o contrato de prestação de serviços primeiro.
        </p>
        <a href={`https://b3rastreamento.com.br/assinar-contrato/${token}`} target="_blank" rel="noreferrer"
          style={{ display: 'block', background: cor || '#1D9E75', color: 'white', borderRadius: '8px', padding: '14px', fontWeight: '700', fontSize: '16px', textDecoration: 'none', marginBottom: '12px' }}>
          ✍️ Assinar Contrato Agora
        </a>
        <button onClick={() => { localStorage.removeItem('token'); localStorage.removeItem('usuario'); window.location.href = '/login'; }}
          style={{ background: 'none', border: 'none', color: '#999', cursor: 'pointer', fontSize: '13px' }}>
          Sair
        </button>
        <p style={{ color: '#ccc', fontSize: '12px', marginTop: '16px' }}>
          Já assinou? <button onClick={() => window.location.reload()} style={{ background: 'none', border: 'none', color: '#1D9E75', cursor: 'pointer', fontSize: '12px', fontWeight: '600' }}>Clique aqui para atualizar</button>
        </p>
      </div>
    </div>
  );
}

function Dashboard() {
  const usuario = JSON.parse(localStorage.getItem('usuario') || '{}');
  const isCliente = usuario.perfil === 'cliente';

  const [sidebarAberta, setSidebarAberta] = useState(false);
  const [targets, setTargets] = useState([]);
  const [targetSelecionado, setTargetSelecionado] = useState(null);
  const [bloqueando, setBloqueando] = useState(false);
  const [ultimaAtualizacao, setUltimaAtualizacao] = useState(null);
  const [endereco, setEndereco] = useState(null);
  const [carregandoEndereco, setCarregandoEndereco] = useState(false);
  const [mostrarStreetView, setMostrarStreetView] = useState(false);
  const [mostrarCompartilhar, setMostrarCompartilhar] = useState(false);
  const [mostrarComandos, setMostrarComandos] = useState(false);
  const [gerandoLink, setGerandoLink] = useState(false);
  const [linkGerado, setLinkGerado] = useState(null);
  const [busca, setBusca] = useState('');

  const [contratoVerificado, setContratoVerificado] = useState(false);
  const [tokenContrato, setTokenContrato] = useState(null);
  const [temContrato, setTemContrato] = useState(true);

  const socketRef = useRef(null);
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  // Colunas da grid: config, ordem e visibilidade personalizáveis por usuário (salvo no navegador)
  const COLUNAS_PADRAO = [
    { key: 'icone', label: '', render: (t) => (
        <>
          {t.icone}
          {estaBloqueado(t) && <span style={{ marginLeft: '4px', fontSize: '13px' }}>🔒</span>}
        </>
      ) },
    { key: 'placa', label: 'Placa', render: (t) => <span style={{ fontWeight: '700', fontFamily: 'monospace' }}>{t.identificador}</span> },
    { key: 'nome', label: 'Nome', render: (t) => t.nome },
    { key: 'cliente', label: 'Cliente', render: (t) => <span style={{ color: '#666' }}>{t.cliente_nome || '—'}</span> },
    { key: 'email', label: 'E-mail', render: (t) => <span style={{ color: '#666' }}>{t.cliente_email || '—'}</span> },
    { key: 'serial', label: 'Serial', render: (t) => <span style={{ color: '#666', fontFamily: 'monospace' }}>{t.equipamento_serial || '—'}</span> },
    { key: 'linha', label: 'Linha', render: (t) => <span style={{ color: '#666' }}>{t.numero_chip || '—'}</span> },
    { key: 'endereco', label: 'Endereço', render: (t) => t.ultima_lat ? <EnderecoInline lat={t.ultima_lat} lng={t.ultima_lng} /> : '—' },
    { key: 'velocidade', label: 'Velocidade', render: (t) => (
        t.ultima_velocidade > 0 ? <span style={{ color: '#22C55E', fontWeight: '600' }}>{t.ultima_velocidade} km/h ⚡</span> : <span style={{ color: '#666', fontWeight: '600' }}>0 km/h</span>
      ) },
    { key: 'ignicao', label: 'Ignição', render: (t) => (
        t.ultima_ignicao === true ? (
          <span style={{ background: '#E1F5EE', color: '#0F6E56', padding: '3px 8px', borderRadius: '12px', fontSize: '11px', fontWeight: '500' }}>🔑 Ligada</span>
        ) : t.ultima_ignicao === false ? (
          <span style={{ background: '#f0f0f0', color: '#666', padding: '3px 8px', borderRadius: '12px', fontSize: '11px', fontWeight: '500' }}>⭘ Desligada</span>
        ) : (
          <span style={{ color: '#ccc', fontSize: '11px' }}>—</span>
        )
      ) },
    { key: 'atualizado', label: 'Última atualização', render: (t) => (
        <span style={{ color: '#666' }}>{t.ultima_atualizacao ? new Date(t.ultima_atualizacao).toLocaleString('pt-BR') : '—'}</span>
      ) },
    { key: 'status', label: 'Status', render: (t) => {
        const st = statusVeiculo(t);
        return (
          <>
            <span style={{ background: st.cor, color: st.corTexto, padding: '3px 8px', borderRadius: '12px', fontSize: '11px', fontWeight: '500' }}>{st.texto}</span>
            {estaBloqueado(t) && <span style={{ marginLeft: '6px', background: '#FCEBEB', color: '#A32D2D', padding: '3px 8px', borderRadius: '12px', fontSize: '11px', fontWeight: '600' }}>🔒 Bloqueado</span>}
          </>
        );
      } },
    { key: 'statusCadastro', label: 'Status cadastro', render: (t) => (
        <span style={{ background: t.status === 'ativo' ? '#E1F5EE' : '#FCEBEB', color: t.status === 'ativo' ? '#0F6E56' : '#A32D2D', padding: '3px 8px', borderRadius: '12px', fontSize: '11px', fontWeight: '500' }}>
          {t.status === 'ativo' ? 'Ativo' : 'Inativo'}
        </span>
      ) },
  ];

  const chaveColunas = `colunas_dashboard_${usuario.id || 'default'}`;

  const [ordemColunas, setOrdemColunas] = useState(() => {
    try {
      const salvo = JSON.parse(localStorage.getItem(chaveColunas) || 'null');
      const chaves = COLUNAS_PADRAO.map(c => c.key);
      if (salvo && Array.isArray(salvo.ordem)) {
        const valida = salvo.ordem.filter(k => chaves.includes(k));
        const faltando = chaves.filter(k => !valida.includes(k));
        return [...valida, ...faltando];
      }
    } catch {}
    return COLUNAS_PADRAO.map(c => c.key);
  });

  const [colunasVisiveis, setColunasVisiveis] = useState(() => {
    try {
      const salvo = JSON.parse(localStorage.getItem(chaveColunas) || 'null');
      if (salvo && salvo.visiveis) return salvo.visiveis;
    } catch {}
    const todas = {};
    COLUNAS_PADRAO.forEach(c => { todas[c.key] = true; });
    return todas;
  });

  const [mostrarConfigColunas, setMostrarConfigColunas] = useState(false);
  const [colunaArrastada, setColunaArrastada] = useState(null);

  useEffect(() => {
    try { localStorage.setItem(chaveColunas, JSON.stringify({ ordem: ordemColunas, visiveis: colunasVisiveis })); } catch {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ordemColunas, colunasVisiveis]);

  const colunasOrdenadas = ordemColunas
    .map(k => COLUNAS_PADRAO.find(c => c.key === k))
    .filter(Boolean)
    .filter(c => colunasVisiveis[c.key] !== false);

  const soltarColunaEm = (keyDestino) => {
    if (!colunaArrastada || colunaArrastada === keyDestino) return;
    setOrdemColunas(prev => {
      const nova = [...prev];
      const origemIdx = nova.indexOf(colunaArrastada);
      const destinoIdx = nova.indexOf(keyDestino);
      if (origemIdx === -1 || destinoIdx === -1) return prev;
      nova.splice(origemIdx, 1);
      nova.splice(destinoIdx, 0, colunaArrastada);
      return nova;
    });
    setColunaArrastada(null);
  };

  const alternarColunaVisivel = (key) => {
    setColunasVisiveis(prev => {
      const visiveisAtuais = Object.values(prev).filter(v => v !== false).length;
      if (prev[key] !== false && visiveisAtuais <= 1) return prev; // mantém ao menos 1 coluna visível
      return { ...prev, [key]: prev[key] === false ? true : false };
    });
  };

  const restaurarColunasPadrao = () => {
    setOrdemColunas(COLUNAS_PADRAO.map(c => c.key));
    const todas = {};
    COLUNAS_PADRAO.forEach(c => { todas[c.key] = true; });
    setColunasVisiveis(todas);
  };

  useEffect(() => {
    if (isCliente && usuario.cliente_id) {
      axios.get(`${API}/contratos/verificar/${usuario.cliente_id}`, { headers })
        .then(r => {
          setTemContrato(r.data.tem_contrato);
          if (!r.data.tem_contrato && r.data.token_contrato) {
            setTokenContrato(r.data.token_contrato);
          }
          setContratoVerificado(true);
        })
        .catch(() => {
          setTemContrato(true);
          setContratoVerificado(true);
        });
    } else {
      setContratoVerificado(true);
    }
  }, []);

  useEffect(() => {
    if (!contratoVerificado || !temContrato) return;
    carregarTargets();
    socketRef.current = io(SOCKET_URL);
    socketRef.current.on('connect', () => console.log('✅ WebSocket conectado'));
    socketRef.current.on('posicao', (dados) => {
      setUltimaAtualizacao(new Date());
      setTargets(prev => prev.map(t => {
        if (t.id === dados.target_id) {
          return { ...t, ultima_lat: dados.lat, ultima_lng: dados.lng, ultima_velocidade: dados.velocidade, ultima_atualizacao: new Date().toISOString() };
        }
        return t;
      }));
      setTargetSelecionado(prev => {
        if (prev && prev.id === dados.target_id) {
          buscarEndereco(dados.lat, dados.lng);
          return { ...prev, ultima_lat: dados.lat, ultima_lng: dados.lng, ultima_velocidade: dados.velocidade, ultima_atualizacao: new Date().toISOString() };
        }
        return prev;
      });
    });
    socketRef.current.on('disconnect', () => console.log('❌ WebSocket desconectado'));
    const interval = setInterval(carregarTargets, 30000);
    return () => {
      clearInterval(interval);
      if (socketRef.current) socketRef.current.disconnect();
    };
  }, [contratoVerificado, temContrato]);

  if (!contratoVerificado) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f5f5' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '32px', marginBottom: '12px' }}>⏳</div>
          <div style={{ color: '#666' }}>Verificando acesso...</div>
        </div>
      </div>
    );
  }

  if (isCliente && !temContrato) {
    return <TelaSemContrato token={tokenContrato} cor="#1D9E75" />;
  }

  const carregarTargets = async () => {
    try {
      const res = await axios.get(`${API}/targets`, { headers });
      setTargets(res.data);
    } catch (err) { console.error(err); }
  };

  const buscarEndereco = async (lat, lng) => {
    if (!lat || !lng) return;
    setCarregandoEndereco(true);
    setEndereco(null);
    try {
      const res = await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json&accept-language=pt-BR`);
      const data = await res.json();
      if (data && data.address) {
        const a = data.address;
        setEndereco({
          rua: a.road || a.pedestrian || a.footway || a.residential || '',
          numero: a.house_number || '',
          bairro: a.suburb || a.neighbourhood || a.quarter || a.city_district || '',
          cidade: a.city || a.town || a.village || a.municipality || a.county || '',
          estado: a.state || '',
        });
      }
    } catch (err) { console.error(err); }
    setCarregandoEndereco(false);
  };

  const selecionarTarget = (t) => {
    setTargetSelecionado(t);
    setMostrarStreetView(false);
    setMostrarCompartilhar(false);
    setMostrarComandos(false);
    setLinkGerado(null);
    setEndereco(null);
    if (t.ultima_lat && t.ultima_lng) buscarEndereco(t.ultima_lat, t.ultima_lng);
  };

  const sair = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
    window.location.href = '/login';
  };

  const enviarBloqueio = async (acao) => {
    if (!window.confirm(`Deseja ${acao} o veículo ${targetSelecionado.identificador}?`)) return;
    setBloqueando(true);
    try {
      const rota = acao === 'bloquear' ? 'bloquear' : 'desbloquear';
      await axios.post(`${API}/targets/${targetSelecionado.id}/${rota}`, {}, { headers });
      const novoStatus = acao === 'bloquear' ? 'BLOQUEAR' : 'DESBLOQUEAR';
      setTargets(prev => prev.map(t => t.id === targetSelecionado.id ? { ...t, ultimo_comando_bloqueio: novoStatus } : t));
      setTargetSelecionado(prev => prev ? { ...prev, ultimo_comando_bloqueio: novoStatus } : prev);
      alert(`Comando de ${acao} enviado com sucesso!`);
    } catch (err) {
      alert(err.response?.data?.erro || 'Erro ao enviar comando');
    }
    setBloqueando(false);
  };

  const gerarLinkCompartilhamento = async (duracao_horas) => {
    setGerandoLink(true);
    setLinkGerado(null);
    try {
      const res = await axios.post(`${API}/compartilhamento`, {
        target_id: targetSelecionado.id,
        duracao_horas,
      }, { headers });
      setLinkGerado(res.data.link);
    } catch (err) {
      alert(err.response?.data?.erro || 'Erro ao gerar link de compartilhamento');
    }
    setGerandoLink(false);
  };

  const copiarLink = () => {
    const textarea = document.createElement('textarea');
    textarea.value = linkGerado;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    try { document.execCommand('copy'); alert('Link copiado!'); } catch (err) { alert('Não foi possível copiar automaticamente.'); }
    document.body.removeChild(textarea);
  };

  const abrirNoWhatsApp = () => {
    const texto = encodeURIComponent(`Acompanhe a localização do veículo: ${linkGerado}`);
    window.open(`https://wa.me/?text=${texto}`, '_blank');
  };

  const statusVeiculo = (t) => {
    if (!t.ultima_lat) return { cor: '#E6F1FB', texto: '⬜ Sem sinal', corTexto: '#185FA5' };
    if (!t.ultima_atualizacao) return { cor: '#E6F1FB', texto: '⬜ Sem sinal', corTexto: '#185FA5' };
    const diff = (new Date() - new Date(t.ultima_atualizacao)) / 1000 / 60;
    if (diff > 10) return { cor: '#FCEBEB', texto: '🔴 Offline', corTexto: '#A32D2D' };
    if (t.ultima_velocidade > 0) return { cor: '#E1F5EE', texto: '🟢 Em movimento', corTexto: '#0F6E56' };
    return { cor: '#FAEEDA', texto: '🟡 Parado', corTexto: '#633806' };
  };

  const estaBloqueado = (t) => t?.ultimo_comando_bloqueio === 'BLOQUEAR';


  // Cor do marcador no mapa: verde = em movimento, amarelo = ligado e parado,
  // cor customizada do veículo = parado e desligado, cinza = sem sinal há mais de 10min
  const corMarcador = (t) => {
    if (!t.ultima_atualizacao) return '#EF4444';
    const diffMin = (new Date() - new Date(t.ultima_atualizacao)) / 1000 / 60;
    if (diffMin > 48 * 60) return '#EF4444';
    if (diffMin > 10) return '#9CA3AF';
    if (t.ultima_velocidade > 0) return '#22C55E';
    if (t.ultima_ignicao) return '#F59E0B';
    return t.cor || '#1D9E75';
  };

  const buscaLower = busca.toLowerCase().trim();
  const targetsFiltrados = buscaLower === '' ? targets : targets.filter(t => {
    return (
      (t.identificador || '').toLowerCase().includes(buscaLower) ||
      (t.nome || '').toLowerCase().includes(buscaLower) ||
      (t.cliente_nome || '').toLowerCase().includes(buscaLower) ||
      (t.equipamento_serial || '').toLowerCase().includes(buscaLower) ||
      (t.equipamento_modelo || '').toLowerCase().includes(buscaLower) ||
      (t.modelo || '').toLowerCase().includes(buscaLower) ||
      (t.numero_chip || '').toLowerCase().includes(buscaLower) ||
      (t.cliente_email || '').toLowerCase().includes(buscaLower)
    );
  });

  const onlines = targets.filter(t => t.ultima_lat).length;

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5', display: 'flex', flexDirection: 'column' }}>
      <Sidebar aberta={sidebarAberta} setAberta={setSidebarAberta} />

      <div style={{ background: '#1D9E75', padding: '0 24px', height: '60px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'fixed', top: 0, left: 0, right: 0, zIndex: 500, boxShadow: '0 2px 10px rgba(0,0,0,0.2)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <button onClick={() => setSidebarAberta(!sidebarAberta)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '22px', color: 'white', lineHeight: 1 }}>
            {sidebarAberta ? '✕' : '☰'}
          </button>
          <span style={{ color: 'white', fontWeight: '700', fontSize: '18px' }}>🛰️ Rastreamento Veicular</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          {ultimaAtualizacao && (
            <span style={{ color: 'rgba(255,255,255,0.8)', fontSize: '12px' }}>⚡ Ao vivo · {ultimaAtualizacao.toLocaleTimeString('pt-BR')}</span>
          )}
          <span style={{ color: 'white', fontSize: '14px' }}>👤 {usuario.nome}</span>
          <button onClick={sair} style={{ background: 'rgba(255,255,255,0.2)', color: 'white', border: '1px solid rgba(255,255,255,0.4)', borderRadius: '8px', padding: '6px 14px', cursor: 'pointer', fontSize: '14px' }}>Sair</button>
        </div>
      </div>

      <div style={{ marginTop: '60px', display: 'flex', height: 'calc(100vh - 60px)' }}>
        <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', position: 'relative' }}>

          <div style={{ position: 'absolute', top: '12px', left: '24px', zIndex: 10, display: 'flex', gap: '10px' }}>
            {[
              { label: 'Total', valor: targets.length, cor: '#1D9E75' },
              { label: 'Online', valor: onlines, cor: '#22C55E' },
              { label: 'Sem Sinal', valor: targets.length - onlines, cor: '#EF4444' },
            ].map((card, i) => (
              <div key={i} style={{ background: 'white', borderRadius: '10px', padding: '10px 16px', boxShadow: '0 2px 12px rgba(0,0,0,0.15)', borderLeft: `3px solid ${card.cor}`, minWidth: '90px' }}>
                <div style={{ fontSize: '20px', fontWeight: '700', color: card.cor }}>{card.valor}</div>
                <div style={{ color: '#666', fontSize: '12px' }}>{card.label}</div>
              </div>
            ))}
          </div>

          <div style={{ flex: '0 0 60%' }}>
            <MapContainer center={[-23.3045, -51.1696]} zoom={12} style={{ height: '100%', width: '100%' }}>
              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution='&copy; OpenStreetMap' />
              <CentralizarMapa alvoId={targetSelecionado?.id} lat={targetSelecionado?.ultima_lat} lng={targetSelecionado?.ultima_lng} />
              {targets.map((t, i) => (
                t.ultima_lat && t.ultima_lng ? (
                  <Marker key={i} position={[parseFloat(t.ultima_lat), parseFloat(t.ultima_lng)]}
                    icon={criarIcone(corMarcador(t), t.icone || '🚗')}
                    eventHandlers={{ click: () => selecionarTarget(t) }}>
                    <Tooltip permanent={false}>
                      <div style={{ fontSize: '12px' }}>
                        <strong>{t.identificador}</strong> — {t.nome}<br />
                        {t.ultima_velocidade || 0} km/h
                      </div>
                    </Tooltip>
                  </Marker>
                ) : null
              ))}
            </MapContainer>
          </div>

          <div style={{ flex: '0 0 40%', background: 'white', overflowY: 'auto', overflowX: 'auto', borderTop: '2px solid #e0e0e0', display: 'flex', flexDirection: 'column' }}>
            <div style={{ padding: '10px 16px', borderBottom: '1px solid #eee', background: '#fafafa', display: 'flex', alignItems: 'center', gap: '10px', position: 'relative' }}>
              <span style={{ fontSize: '16px' }}>🔍</span>
              <input type="text" placeholder="Buscar por placa, nome, cliente, serial, linha ou e-mail..." value={busca} onChange={e => setBusca(e.target.value)}
                style={{ flex: 1, padding: '7px 12px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '13px', outline: 'none', background: 'white' }} />
              {busca && <button onClick={() => setBusca('')} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '18px', color: '#999', padding: '0 4px', lineHeight: 1 }}>×</button>}
              {busca && <span style={{ fontSize: '12px', color: '#999', whiteSpace: 'nowrap' }}>{targetsFiltrados.length} resultado{targetsFiltrados.length !== 1 ? 's' : ''}</span>}
              <button onClick={() => setMostrarConfigColunas(!mostrarConfigColunas)}
                style={{ background: mostrarConfigColunas ? '#1D9E75' : 'white', color: mostrarConfigColunas ? 'white' : '#555', border: '1px solid #ddd', borderRadius: '8px', padding: '7px 12px', fontSize: '12px', fontWeight: '600', cursor: 'pointer', whiteSpace: 'nowrap' }}>
                ⚙️ Colunas
              </button>
              {mostrarConfigColunas && (
                <div style={{ position: 'absolute', top: '46px', right: '16px', zIndex: 20, background: 'white', border: '1px solid #ddd', borderRadius: '10px', boxShadow: '0 4px 16px rgba(0,0,0,0.15)', padding: '14px', width: '230px' }}>
                  <div style={{ fontSize: '11px', color: '#999', marginBottom: '8px' }}>Marque as colunas visíveis. Arraste os cabeçalhos da tabela pra reordenar.</div>
                  {COLUNAS_PADRAO.map(c => (
                    <label key={c.key} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '5px 0', fontSize: '13px', color: '#333', cursor: 'pointer' }}>
                      <input type="checkbox" checked={colunasVisiveis[c.key] !== false} onChange={() => alternarColunaVisivel(c.key)} />
                      {c.label || '(ícone)'}
                    </label>
                  ))}
                  <button onClick={restaurarColunasPadrao} style={{ marginTop: '10px', width: '100%', background: '#f0f0f0', color: '#555', border: 'none', borderRadius: '6px', padding: '7px', fontSize: '12px', fontWeight: '600', cursor: 'pointer' }}>
                    Restaurar padrão
                  </button>
                </div>
              )}
            </div>

            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead style={{ position: 'sticky', top: 0, background: '#f8f8f8', zIndex: 1 }}>
                <tr>
                  {colunasOrdenadas.map(col => (
                    <th key={col.key}
                      draggable
                      onDragStart={() => setColunaArrastada(col.key)}
                      onDragOver={e => e.preventDefault()}
                      onDrop={() => soltarColunaEm(col.key)}
                      title="Arraste para reordenar"
                      style={{ padding: '10px 14px', textAlign: 'left', fontSize: '12px', color: '#666', fontWeight: '600', borderBottom: '1px solid #eee', whiteSpace: 'nowrap', cursor: 'grab', userSelect: 'none', background: colunaArrastada === col.key ? '#eee' : undefined }}>
                      {col.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {targetsFiltrados.length === 0 ? (
                  <tr><td colSpan={colunasOrdenadas.length} style={{ padding: '24px', textAlign: 'center', color: '#999', fontSize: '13px' }}>
                    {busca ? `Nenhum veículo encontrado para "${busca}"` : 'Nenhum veículo cadastrado.'}
                  </td></tr>
                ) : targetsFiltrados.map((t, i) => {
                  return (
                    <tr key={i} onClick={() => selecionarTarget(t)}
                      style={{ borderBottom: '1px solid #f0f0f0', cursor: 'pointer', background: targetSelecionado?.id === t.id ? '#E1F5EE' : 'white' }}
                      onMouseEnter={e => { if (targetSelecionado?.id !== t.id) e.currentTarget.style.background = '#f9f9f9' }}
                      onMouseLeave={e => { if (targetSelecionado?.id !== t.id) e.currentTarget.style.background = 'white' }}>
                      {colunasOrdenadas.map(col => (
                        <td key={col.key} style={{ padding: '10px 14px', fontSize: col.key === 'icone' ? '20px' : '13px' }}
                          title={col.key === 'icone' && estaBloqueado(t) ? 'Veículo bloqueado' : undefined}>
                          {col.render(t)}
                        </td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

        {targetSelecionado && (
          <div style={{ width: '400px', flexShrink: 0, background: 'white', borderLeft: '1px solid #e0e0e0', overflowY: 'auto', display: 'flex', flexDirection: 'column' }}>
            <div style={{ padding: '16px 20px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h3 style={{ margin: 0, fontSize: '16px' }}>{targetSelecionado.icone} {targetSelecionado.identificador}</h3>
              <button onClick={() => { setTargetSelecionado(null); setMostrarStreetView(false); setMostrarCompartilhar(false); setMostrarComandos(false); setLinkGerado(null); setEndereco(null); }}
                style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '20px', color: '#999' }}>×</button>
            </div>

            <div style={{ padding: '12px 16px', borderBottom: '1px solid #eee' }}>
              <div style={{ display: 'flex', gap: '8px', marginBottom: '12px' }}>
                <button onClick={() => setMostrarStreetView(false)}
                  style={{ flex: 1, background: !mostrarStreetView ? '#1D9E75' : '#f0f0f0', color: !mostrarStreetView ? 'white' : '#666', border: 'none', borderRadius: '6px', padding: '7px', cursor: 'pointer', fontSize: '12px', fontWeight: '600' }}>
                  📍 Info
                </button>
                <button onClick={() => setMostrarStreetView(true)}
                  style={{ flex: 1, background: mostrarStreetView ? '#1D9E75' : '#f0f0f0', color: mostrarStreetView ? 'white' : '#666', border: 'none', borderRadius: '6px', padding: '7px', cursor: 'pointer', fontSize: '12px', fontWeight: '600' }}>
                  🌍 Street View
                </button>
              </div>

              {mostrarStreetView ? (
                <div>
                  <iframe title="mapa" width="100%" height="200" frameBorder="0"
                    style={{ borderRadius: '10px', border: 'none', display: 'block' }}
                    src={`https://maps.google.com/maps?q=${targetSelecionado.ultima_lat},${targetSelecionado.ultima_lng}&t=k&z=18&ie=UTF8&iwloc=&output=embed`}
                    allowFullScreen />
                  <a href={`https://www.google.com/maps?layer=c&cbll=${targetSelecionado.ultima_lat},${targetSelecionado.ultima_lng}`}
                    target="_blank" rel="noopener noreferrer"
                    style={{ display: 'block', textAlign: 'center', marginTop: '8px', color: '#1D9E75', fontSize: '12px', textDecoration: 'none', fontWeight: '600' }}>
                    🔗 Abrir Street View no Google Maps
                  </a>
                </div>
              ) : (
                <div>
                  <div style={{ background: '#f8f8f8', borderRadius: '10px', padding: '12px', marginBottom: '10px' }}>
                    <div style={{ fontSize: '11px', color: '#999', fontWeight: '600', marginBottom: '6px' }}>📍 LOCALIZAÇÃO ATUAL</div>
                    {carregandoEndereco ? (
                      <div style={{ fontSize: '12px', color: '#999' }}>⏳ Buscando endereço...</div>
                    ) : endereco ? (
                      <div style={{ fontSize: '12px', color: '#333', lineHeight: '1.7' }}>
                        <div><strong>{endereco.rua || 'Via não identificada'}{endereco.numero ? `, nº ${endereco.numero}` : ''}</strong></div>
                        {endereco.bairro && <div style={{ color: '#555' }}>{endereco.bairro}</div>}
                        <div style={{ color: '#666' }}>{endereco.cidade || 'Cidade não identificada'}{endereco.estado ? ` — ${endereco.estado}` : ''}</div>
                      </div>
                    ) : (
                      <div style={{ fontSize: '12px', color: '#999' }}>
                        {targetSelecionado.ultima_lat ? `${parseFloat(targetSelecionado.ultima_lat).toFixed(5)}, ${parseFloat(targetSelecionado.ultima_lng).toFixed(5)}` : 'Sem localização'}
                      </div>
                    )}
                  </div>

                  <div style={{ background: '#f8f8f8', borderRadius: '10px', padding: '12px' }}>
                    <div style={{ fontSize: '13px', color: '#666', lineHeight: '2' }}>
                      <div><strong>Nome:</strong> {targetSelecionado.nome}</div>
                      <div><strong>Cliente:</strong> <span style={{ color: '#1D9E75', fontWeight: '600' }}>{targetSelecionado.cliente_nome || '—'}</span></div>
                      <div><strong>Serial:</strong> <span style={{ fontFamily: 'monospace', fontSize: '12px' }}>{targetSelecionado.equipamento_serial || '—'}</span></div>
                      <div><strong>Tipo:</strong> {targetSelecionado.tipo || '—'}</div>
                      <div><strong>Status:</strong> {(() => { const st = statusVeiculo(targetSelecionado); return <span style={{ color: st.corTexto, fontWeight: '600' }}>{st.texto}</span>; })()}</div>
                      <div><strong>Bloqueio:</strong> {estaBloqueado(targetSelecionado) ? <span style={{ color: '#A32D2D', fontWeight: '600' }}>🔒 Bloqueado</span> : <span style={{ color: '#0F6E56', fontWeight: '600' }}>🔓 Desbloqueado</span>}</div>
                      <div><strong>Velocidade:</strong> <span style={{ color: targetSelecionado.ultima_velocidade > 0 ? '#22C55E' : '#666', fontWeight: '600' }}>{targetSelecionado.ultima_velocidade || 0} km/h</span></div>
                      <div><strong>Atualizado:</strong> {targetSelecionado.ultima_atualizacao ? new Date(targetSelecionado.ultima_atualizacao).toLocaleString('pt-BR') : '—'}</div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div style={{ padding: '12px 16px' }}>
              <button onClick={() => setMostrarComandos(!mostrarComandos)}
                style={{ width: '100%', background: mostrarComandos ? '#1D9E75' : '#f0f0f0', color: mostrarComandos ? 'white' : '#333', border: 'none', borderRadius: '8px', padding: '11px', cursor: 'pointer', fontWeight: '700', fontSize: '13px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
                ⚡ Comandos {mostrarComandos ? '▲' : '▼'}
              </button>
              {mostrarComandos && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '8px' }}>
              {(() => {
                const isAdmin = usuario.perfil === 'superadmin' || usuario.perfil === 'admin';
                const clienteTem = targetSelecionado?.plano_cliente !== 'sem_bloqueio';
                const podeBloquear = isAdmin || (usuario.perfil === 'cliente' && clienteTem);
                return podeBloquear ? (
                  <>
                    <button onClick={() => enviarBloqueio('bloquear')} disabled={bloqueando}
                      style={{ background: bloqueando ? '#ccc' : '#FCEBEB', color: '#A32D2D', border: 'none', borderRadius: '8px', padding: '10px', cursor: bloqueando ? 'not-allowed' : 'pointer', fontWeight: '600', fontSize: '13px' }}>
                      🔒 {bloqueando ? 'Enviando...' : 'Bloquear Veículo'}
                    </button>
                    <button onClick={() => enviarBloqueio('desbloquear')} disabled={bloqueando}
                      style={{ background: bloqueando ? '#ccc' : '#E1F5EE', color: '#0F6E56', border: 'none', borderRadius: '6px', padding: '10px', cursor: bloqueando ? 'not-allowed' : 'pointer', fontWeight: '600', fontSize: '13px' }}>
                      🔓 {bloqueando ? 'Enviando...' : 'Desbloquear Veículo'}
                    </button>
                  </>
                ) : null;
              })()}
              <button onClick={async () => {
                try {
                  const r = await fetch(`${API}/targets/${targetSelecionado.id}/requisitar-posicao`, { method: 'POST', headers });
                  const data = await r.json();
                  if (data.sucesso) alert('✅ ' + data.mensagem);
                  else alert('⚠️ ' + (data.erro || 'Erro ao requisitar posição'));
                } catch { alert('Erro ao requisitar posição'); }
              }}
                style={{ background: '#E1F5EE', color: '#0F6E56', border: 'none', borderRadius: '8px', padding: '10px', cursor: 'pointer', fontWeight: '600', fontSize: '13px' }}>
                📡 Requisitar Posição Agora
              </button>
              <button onClick={() => window.location.href = `/relatorios?target=${targetSelecionado.id}`}
                style={{ background: '#E6F1FB', color: '#185FA5', border: 'none', borderRadius: '8px', padding: '10px', cursor: 'pointer', fontWeight: '600', fontSize: '13px' }}>
                📍 Ver Histórico de Rota
              </button>
              <a href={`https://www.google.com/maps?q=${targetSelecionado.ultima_lat},${targetSelecionado.ultima_lng}`}
                target="_blank" rel="noopener noreferrer"
                style={{ background: '#f0f0f0', color: '#333', borderRadius: '8px', padding: '10px', fontWeight: '600', fontSize: '13px', textAlign: 'center', textDecoration: 'none', display: 'block' }}>
                🗺️ Abrir no Google Maps
              </a>
              <button onClick={() => { setMostrarCompartilhar(!mostrarCompartilhar); setLinkGerado(null); }}
                style={{ background: '#FAEEDA', color: '#633806', border: 'none', borderRadius: '8px', padding: '10px', cursor: 'pointer', fontWeight: '600', fontSize: '13px' }}>
                📤 Compartilhar Localização
              </button>
              {mostrarCompartilhar && (
                <div style={{ background: '#f8f8f8', borderRadius: '10px', padding: '12px' }}>
                  {!linkGerado ? (
                    <>
                      <div style={{ fontSize: '12px', color: '#666', marginBottom: '8px', fontWeight: '600' }}>Por quanto tempo o link fica disponível?</div>
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
                        {[2, 6, 8, 24].map((h) => (
                          <button key={h} onClick={() => gerarLinkCompartilhamento(h)} disabled={gerandoLink}
                            style={{ background: gerandoLink ? '#ccc' : '#1D9E75', color: 'white', border: 'none', borderRadius: '6px', padding: '8px', cursor: gerandoLink ? 'not-allowed' : 'pointer', fontWeight: '600', fontSize: '12px' }}>
                            {gerandoLink ? '...' : `${h}h`}
                          </button>
                        ))}
                      </div>
                    </>
                  ) : (
                    <div>
                      <div style={{ fontSize: '12px', color: '#0F6E56', fontWeight: '600', marginBottom: '8px' }}>✅ Link gerado com sucesso!</div>
                      <div style={{ background: 'white', border: '1px solid #ddd', borderRadius: '6px', padding: '8px', fontSize: '11px', color: '#333', wordBreak: 'break-all', marginBottom: '8px' }}>{linkGerado}</div>
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <button onClick={copiarLink} style={{ flex: 1, background: '#f0f0f0', color: '#333', border: 'none', borderRadius: '6px', padding: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '12px' }}>📋 Copiar</button>
                        <button onClick={abrirNoWhatsApp} style={{ flex: 1, background: '#22C55E', color: 'white', border: 'none', borderRadius: '6px', padding: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '12px' }}>💬 WhatsApp</button>
                      </div>
                    </div>
                  )}
                </div>
              )}
                </div>
              )}
            </div>
            <p style={{ textAlign: 'center', margin: '8px 0 16px', color: '#999', fontSize: '11px' }}>
              Desenvolvido por <a href="https://digitalmaisbr.com.br" style={{ color: '#1D9E75' }}>Digital Mais BR</a>
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default Dashboard;